import { ApiServiceV1 } from './api.service';

export const AppApiService = {
  async getAppSettings() {
    const { data } = await ApiServiceV1.get('auth/settings');
    return data;
  },
};

export default AppApiService;
